<template>
  <div id="rightMainContainer" :style="{ width: rightW ? rightW : 'calc(100% - 230px)' }">
    <operations ref="operations" @callback="refreshTable"></operations>
    <navAndSearch></navAndSearch>
    <fileTable ref="fileTable"></fileTable>
    <compress/>
  </div>
</template>

<script>
import navAndSearch from "./nav.vue";
import fileTable from "@/views/project/document/fileTable";
import operations from "@/CommonDP/pages/mainMg/project/document/rightMain/operations/operations";
import { mapState } from "vuex";
import compress from './compress.vue'
export default {
  components: {
    navAndSearch,
    fileTable,
    operations,
    compress
  },

  computed: {
    ...mapState({
      rightW: state => state.XtDesign.rightW
    })
  },
  methods: {
    refreshTable() {
      this.$refs.fileTable.keyone += 1;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#rightMainContainer {
  height: 100%;
  overflow: hidden;
  margin-left: var(--middle-space);
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
}
</style>
